import { render, staticRenderFns } from "./SurveyCustomer.vue?vue&type=template&id=b8ede150&"
import script from "./SurveyCustomer.vue?vue&type=script&lang=js&"
export * from "./SurveyCustomer.vue?vue&type=script&lang=js&"
import style0 from "./SurveyCustomer.vue?vue&type=style&index=0&id=b8ede150&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports